@if (shouldShowChat) {
  <section class="kx-ai-chat-embed">
    <kx-ai-chat #chatElement id="kx-ai-chat"></kx-ai-chat>
  </section>
}
